import script from "./ViewRebateStat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewRebateStat.vue?vue&type=script&setup=true&lang=ts"

import "./ViewRebateStat.vue?vue&type=style&index=0&id=dcfa9c86&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcfa9c86"]])

export default __exports__